import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Table } from 'semantic-ui-react';
import Text from './Text';
import styles from '../../Form.scss';
import { RootConsumer } from '../../../../RootComponent';

const TextTableWidget = ({ schema, uiSchema, onChange, formData, removeResponse }) => {
  const onCellChange = (value, key) => {
    const newFormData = _.cloneDeep(formData);
    newFormData[key] = value;
    onChange(newFormData);
  };
  return (
    <RootConsumer>
      {({ isMobile }) =>
        <Table.Row>
          {uiSchema['ui:headers'].map((item, index) =>
            <Table.Cell key={index}>
              <Text
                schema={schema.items.properties[item]}
                value={formData[item]}
                label={isMobile && schema.items.properties[item].title}
                onChange={value => onCellChange(value, item)}
              />
            </Table.Cell>
          )}
          <Table.Cell>
            <div
              className={styles.deleteItemRelative}
              style={{ marginTop: '-0.5em' }}
              onClick={removeResponse}
            >
              <Icon name='close' />
            </div>
          </Table.Cell>
        </Table.Row>}
    </RootConsumer>
  );
};

TextTableWidget.propTypes = {
  editing: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  uiSchema: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  removeResponse: PropTypes.func.isRequired
};

export default TextTableWidget;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Widgets/Table.js